<template>
  <div>
    <LoadingScreen :isLoading="loading"></LoadingScreen>
    <div v-if="daysToMembershipEnd === 2"
      class="bg-green-50 rounded-lg shadow p-4 w-full border border-green-200 mb-3 flex flex-row items-center gap-4">
      <div class="flex-shrink-0">
        <svg class="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex-grow">
        <h3 class="text-md font-semibold text-green-800">Tu cuenta se suspenderá en 3 días si no actualizas tu método de
          pago.</h3>
        <p class="text-sm text-green-700 mt-1">Actualiza tu método de pago para continuar sin interrupciones.</p>
      </div>
      <button @click="viewCustomerPortal"
        class="flex-shrink-0 bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg">
        Actualizar método de pago
      </button>
    </div>
    <div v-if="daysToMembershipEnd === 1"
      class="bg-yellow-100 rounded-lg shadow p-4 w-full border border-yellow-600 mb-3 flex flex-row items-center gap-4">
      <div class="flex-shrink-0">
        <svg class="w-6 h-6 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex-grow">
        <h3 class="text-md font-semibold text-yellow-800">Tu cuenta se suspenderá en 2 días si no actualizas tu método
          de pago.</h3>
        <p class="text-sm text-yellow-700 mt-1">Actualiza tu método de pago para continuar sin interrupciones.</p>
      </div>
      <button @click="viewCustomerPortal"
        class="flex-shrink-0 bg-yellow-600 hover:bg-yellow-700 text-white font-semibold py-2 px-4 rounded-lg">
        Actualizar método de pago
      </button>
    </div>
    <div v-if="daysToMembershipEnd === 0"
      class="bg-red-50 rounded-lg shadow p-4 w-full border border-red-200 mb-3 flex flex-row items-center gap-4">
      <div class="flex-shrink-0">
        <svg class="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex-grow">
        <h3 class="text-md font-semibold text-red-800">Último día de acceso.</h3>
        <p class="text-sm text-red-700 mt-1">Tu cuenta se suspenderá hoy si no actualizas tu método de pago.</p>
      </div>
      <button @click="viewCustomerPortal"
        class="flex-shrink-0 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg">
        Evitar suspensión ahora
      </button>
    </div>
    <el-dialog :visible.sync="visible" width="30%" @close="close" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="text-center">
        <div class="mb-6">
          <img src="@/assets/img/welcome-samii.png" width="200px" class="m-auto" />
        </div>
        <h3 class="text-xl font-bold text-gray-800 mb-2">Tu negocio está en pausa temporalmente</h3>
        <p class="text-md text-gray-600 mb-2">El acceso a las funciones está temporalmente limitado hasta que reactives
          tu cuenta.</p>
        <p class="text-md text-gray-600 mb-2">Tus datos están seguros y disponibles.</p>
        <p class="text-sm text-gray-500 mb-2">Reactivar toma menos de un minuto.</p>
        <button @click="visiblePaymentLink = true"
          class="w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-lg mb-4 flex items-center justify-center gap-2">
          Reactivar y continuar trabajando
          <i class="bx bx-arrow-right font-white"></i>
        </button>
        <div class="text-center">
          <span class="text-sm text-gray-600 mb-1">¿Ya realizaste tu pago? </span>
          <span class="text-sm text-purple-600 cursor-pointer flex items-center justify-center gap-2"
            @click="syncStripeAccount">
            <i class="bx bx-info-circle"></i>
            Si no se ha visto reflejado, da click aquí
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visiblePaymentLink" width="760px" @close="close" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="pl-5 pr-5 pt-1 pb-1 w-full">
        <h2 class="text-2xl font-semibold text-gray-800 text-center mb-2">Elige tu plan para continuar</h2>
        <p class="text-md text-gray-500 text-center mb-2">Tus datos siguen aquí. Reactiva en menos de un minuto.</p>

        <!-- Billing toggle -->
        <div class="mb-3 flex items-center justify-center">
          <div class="bg-gray-100 rounded-full p-1 inline-flex items-center">
            <button @click="billingPeriod = 'monthly'"
              :class="billingPeriod === 'monthly' ? 'bg-white text-gray-800 shadow px-5 py-2' : 'text-gray-500 px-5 py-2'"
              class="rounded-full text-sm font-medium focus:outline-none transition">Mensual</button>
            <button @click="billingPeriod = 'annual'"
              :class="billingPeriod === 'annual' ? 'bg-white text-gray-800 shadow px-5 py-2 ml-1' : 'text-gray-500 px-5 py-2 ml-1'"
              class="rounded-full text-sm font-medium focus:outline-none transition">
              Anual
              <span
                class="ml-2 inline-block text-xs font-semibold text-purple-600 bg-purple-100 rounded-full px-2 py-0.5">2
                meses gratis</span>
            </button>
          </div>
        </div>
        <!-- Plans -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
          <div v-for="plan in membershipPlans" :key="plan.id" @click="selectPlan(plan.id)"
            :class="['rounded-lg p-5 cursor-pointer transition', selection[0] === plan.id ? 'border-2 border-purple-600 bg-white shadow-md ring-2 ring-purple-200' : 'border border-gray-200 bg-white']">
            <div class="flex items-start justify-between">
              <div>
                <div class="text-md text-gray-500 font-bold uppercase">{{ plan.name }}</div>
                <div class="text-2xl font-bold text-gray-900 mt-2">
                  ${{ displayPrice(plan) }}
                  <span class="text-sm font-medium text-gray-500">/mes</span>
                </div>
                <div class="text-sm text-gray-500 mt-2">{{ plan.description }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <div class="text-xs text-gray-500 mb-2">INCLUIDO EN PLAN <span class="font-bold text-md">{{ selectedPlan ?
                selectedPlan.name.toUpperCase() : '' }}</span></div>
              <ul class="space-y-1">
                <li v-for="(f, idx) in (selectedPlan ? selectedPlan.features : [])" :key="idx"
                  class="flex items-start gap-1 text-gray-700">
                  <svg class="w-5 h-5 text-purple-600 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span class="text-sm">{{ f }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <button @click="continueToPayment"
          class="mt-4 w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-lg">
          Continuar al pago - ${{ priceForSelectedPlan }}/mes
        </button>
        <p class="text-center text-xs text-gray-500 mt-2">Pago seguro procesado por Stripe</p>
        <p class="text-center text-xs text-gray-400 mt-2">Al pagar aceptas los términos de servicio de Samii</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import error from "@/mixins/error";
import { AccountTypeEnum } from "@/constants";
import PaymentService from "@/services/PaymentService";

export default {
  name: "BannerMembership",
  mixins: [error],
  components: {
    LoadingScreen: () => import("@/components/layouts/LoadingScreen"),
  },
  data() {
    return {
      loading: false,
      visible: false,
      visiblePaymentLink: false,
      selection: [],
      hideScroll: false,
      priceForSelectedPlan: 0,
      selectedPlan: null,
      billingPeriod: 'monthly',
      membershipPlans: [
        {
          id: 'basico',
          name: 'Básico',
          description: '1 sucursal · Funciones esenciales',
          prices: { mensual: 19.99, anual: 16.70 },
          features: [
            'Administración de tareas, clientes y stock',
            'Administración de servicios y proveedores',
            'App móvil',
            'Finanzas básicas (ventas)',
            '1 sucursal', 'Usuarios ilimitados',
          ],
          paymentLinks: {
            monthly: 'https://buy.stripe.com/28EaEY8ZK4105b1bfe57W06?prefilled_email=',
            annual: 'https://buy.stripe.com/4gM14o7VGbts8nd0AA57W07?prefilled_email=',
          },
          paymentLinksMXN: {
            monthly: 'https://buy.stripe.com/6oU7sM5NydBA8nddnm57W00?prefilled_email=',
            annual: 'https://buy.stripe.com/8x2fZi5NygNMdHxbfe57W01?prefilled_email=',
          },
        },
        {
          id: 'pro',
          name: 'Pro',
          description: 'Hasta 3 sucursales · Finanzas completas',
          prices: { mensual: 34.99, anual: 29.16 },
          features: [
            'Incluye todo lo anterior, más:',
            'Finanzas completas',
            'Alerta de stock bajo',
            'Órdenes de compra',
            'Control de gastos (fijos y variables)',
            'Estadísticas y reportes',
            '1 a 3 sucursales',
          ],
          paymentLinks: {
            monthly: 'https://buy.stripe.com/14A9AU1xi2WW9rh0AA57W08?prefilled_email=',
            annual: 'https://buy.stripe.com/3cI6oIcbWeFEfPFdnm57W09?prefilled_email=',
          },
          paymentLinksMXN: {
            monthly: 'https://buy.stripe.com/3cI3cwa3OgNM0UL3MM57W02?prefilled_email=',
            annual: 'https://buy.stripe.com/6oU3cwek49lkdHxfvu57W03?prefilled_email=',
          },
        },
        {
          id: 'pro_franquicias',
          name: 'Pro Franquicias',
          description: '+3 sucursales · Control multi-sede',
          prices: { mensual: 49.99, anual: 41.65 },
          features: [
            'Incluye todo lo anterior, más:',
            '3 o más sucursales',
            'Multisucursal completo',
          ],
          paymentLinks: {
            monthly: 'https://buy.stripe.com/dRm28sb7S9lkdHx3MM57W0a?prefilled_email=',
            annual: 'https://buy.stripe.com/00wcN65Ny7dcgTJ83257W0b?prefilled_email=',
          },
          paymentLinksMXN: {
            monthly: 'https://buy.stripe.com/cNi14o7VGdBA1YP4QQ57W04?prefilled_email=',
            annual: 'https://buy.stripe.com/00w6oI5Ny55432Tcji57W05?prefilled_email=',
          },
        },
      ]
    };
  },
  mounted() {
    if (this.daysToMembershipEnd !== null && this.daysToMembershipEnd < 0) {
      this.visible = true;
    }
    this.selectPlan(this.membershipPlans[0].id);
  },
  methods: {
    continueToPayment() {
      if (!this.selectedPlan) {
        this.$swal.fire({
          title: "Selecciona un plan.",
          icon: "warning",
          text: "Por favor, selecciona un plan para continuar al pago.",
        });
        return;
      }
      var email = this.$store.state.account.email;

      var link = this.selectedPlan.paymentLinks[this.billingPeriod] + email;
      if (this.$store.state.business.country === 'México') {
        link = this.selectedPlan.paymentLinksMXN[this.billingPeriod] + email;
      }
      window.location.href = link;
    },
    selectPlan(planId) {
      this.selection = [planId];
      const plan = this.membershipPlans.find(p => p.id === planId);
      this.selectedPlan = plan;
      this.priceForSelectedPlan = this.displayPrice(plan);
    },
    displayPrice(plan) {
      return this.billingPeriod === 'monthly' ? plan.prices.mensual : plan.prices.anual;
    },
    close() {
      this.visible = false;
    },
    goToMembership() {
      this.$router.push({ name: 'administration.membership' });
    },
    viewCustomerPortal() {
      if (this.$store.state.account.accountType !== AccountTypeEnum.Owner) {
        this.$swal.fire({
          title: "Acceso Denegado.",
          icon: "error",
          text: "Los pagos se deben realizar desde la cuenta madre (Dueño) con la que se inicio en samii.",
        });
        return;
      }

      this.$router.push({ name: 'administration.membership' });
      return;

    },
    async syncStripeAccount() {
      try {
        this.loading = true;
        await PaymentService.syncStripeAccount(this.$store.state.account.id);
        this.$swal.fire({
          title: "Cuenta sincronizada.",
          icon: "success",
          text: "El proceso de sincronización se ha completado exitosamente. Si realizaste un pago recientemente, debería reflejarse en tu cuenta ahora.",
          timer: 10000,
          timerProgressBar: true,
          confirmButtonText: "Aceptar"
        }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        this.handleError(error);
        this.$swal.fire({
          title: "Error al sincronizar.",
          icon: "error",
          text: "Hubo un error al sincronizar la información de tu cuenta. Por favor, intenta nuevamente más tarde.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    isLastDayOfTrial() {
      return this.daysToMembershipEnd === 1;
    },
    daysToMembershipEnd() {
      const endDate = this.$store.state.account.membershipEndDate;
      if (!endDate) return null;
      const today = new Date();
      const end = new Date(endDate);
      end.setHours(end.getHours() + 6);
      const diffTime = end - today;
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
  },
};
</script>
